import { useState, useEffect, useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import FormBaseLayout from "../../components/FormBaseLayout";
import { obtenerRegistrosPosicionPorFecha } from "../../services/indexedbd/palmaQueries";  
import { useQrManager } from "./hook/useQrManager";

import styleRegistro from '../registroPosicion/RegistroPosicionLayout.module.css';
import estiloResumen from '../resumen/ResumenJornadaLayout.module.css';
import estiloScanner from './ScannerJornada.module.css';

import IconQR from "../../components_svg/IconQR";

const GenerarQrJornada = () => {
    const [fecha, setFecha] = useState<string>("");
    const [listaQrs, setListaQrs] = useState<string[]>([]);
    const { generarQrsComprimidos } = useQrManager();
    const qrContainerRef = useRef<HTMLDivElement>(null);

    const [isGenerated, setIsGenerated] = useState(false);

    useEffect(() => {
        setListaQrs([]);
    }, [fecha]);

    useEffect(() => {
        if (listaQrs.length > 0 && qrContainerRef.current) {
            qrContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [listaQrs]);

    const handleExecute = async () => {
        if (!fecha) throw new Error("Debe seleccionar una fecha");
        setListaQrs([]); 

        const registros = await obtenerRegistrosPosicionPorFecha(fecha);
        if (!registros || registros.length === 0) throw new Error("No hay registros");

        // Manteniendo los 5 puntos para máxima claridad
        const qrs = generarQrsComprimidos(registros, 6);
        setListaQrs(qrs);

        setIsGenerated(true)

        return `Listo: ${qrs.length} QR generados.`;
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            <FormBaseLayout
                buttonText="Crear Códigos"
                onExecute={handleExecute}
                disabled={isGenerated}>

                <section className={styleRegistro.contenedorLogo}>
                    <figure>
                        <IconQR width={100} height={100}/>
                    </figure>
                    
                    <h3 className={estiloResumen.titulo}>
                        GENERAR QR DE JORNADA
                    </h3>
                </section>
                
                <aside className={styleRegistro.groupInput}>
                    <label 
                        className={styleRegistro.label}
                        htmlFor="fecha">Fecha de la Jornada</label>
                    <input 
                        id="fecha" 
                        className={styleRegistro.input}
                        type="date"  
                        value={fecha}
                        onChange={(e) => setFecha(e.target.value)}
                    />
                </aside>
            </FormBaseLayout>

            {/* CONTENEDOR SIN FONDO GRIS */}
            {listaQrs.length > 0 && (
                <div 
                    ref={qrContainerRef}
                    style={{ 
                        marginTop: '1rem', 
                        display: 'flex', 
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '40px', 
                        width: '100%',
                        padding: '2rem 0' 
                    }}
                >
                    {listaQrs.map((qrData, index) => (
                        <div key={index} style={{ textAlign: 'center' }}>
                            <p style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px' }}>
                                PARTE {index + 1}
                            </p>
                            
                            <QRCodeSVG 
                                value={qrData} 
                                // Tamaño dinámico para que no se pierda el centrado
                                size={window.innerWidth < 350 ? 280 : 320} 
                                level="M" 
                                includeMargin={true}
                                style={{ 
                                    backgroundColor: '#fff',
                                    border: '1px solid #eee', // Borde sutil solo para delimitar
                                    borderRadius: '10px'
                                }} 
                            />
                        </div>
                    ))}
                    
                    <button 
                        onClick={() => { 
                            setListaQrs([]); setFecha("");
                            setIsGenerated(false); 
                        }}
                        className={[estiloScanner.submit, estiloScanner.reset].join(' ')}
                    >
                        Limpiar pantalla
                    </button>
                </div>
            )}
        </div>
    );
};

export default GenerarQrJornada;